import configureStore from './configureStore';
import RootComponent from './components/RootComponent';
import { AppContainer } from 'react-hot-loader';

const initialState = window.__LOGIN_INITIAL_STATE__;
const store = configureStore({ initialState });
const rootElement = document.getElementById('ReactLoginPage');

if (process.env.NODE_ENV !== 'production') {
  window.store = store;
}

reactDOM.render(
  <AppContainer>
    <RootComponent store={store} />
  </AppContainer>,
  rootElement
);

if (module.hot) {
  module.hot.accept('./components/RootComponent', () => {
    const NextRootComponent = require('./components/RootComponent').default;
    reactDOM.render(
      <AppContainer>
        <NextRootComponent store={store} />
      </AppContainer>,
      rootElement
    );
  });
}
